<template>
    <div class="mt-4">
        <div class="card course-calculator-card card-watermark" :style="errors.residence_id ? 'border: 2px solid red;' : '' + ` --logo-url: url(${base_url}/storage/logo.png)`">
            <Accordion value="0">
                <AccordionPanel value="0">
                    <AccordionHeader>
                        <div class="accordion-header-content">
                            <div class="d-flex align-items-start">
                                <i class="fal fa-house component-header-icon"></i>
                                <div>
                                    <h2 class="component-title">{{ tra.accommodation }}</h2>
                                    <p class="component-sub-title">{{ tra.select_suitable_accommodation }}</p>
                                    <p v-if="errors.residence_id" class="text-danger">{{ errors.residence_id[0] }}</p>
                                </div>
                            </div>
                            <div class="d-flex head-input-fields">
                                
                                <button v-if="is_dashboard_user" @click.stop="showCustomResidenceDialog = true" type="button" class="btn rounded-10 bg-secondary-color text-white custom-residence-btn py-1 ml-3">
                                    <i class="fal fa-plus"></i> {{ tra.add_custom_accommodation }}
                                </button>


                                <div @click.stop>
                                    <WeeksComponent v-model:weeks="residenceWeeksValue" :placeholder="tra.accommodation_duration" :tra="tra" />
                                </div>
                            </div>
                        </div>
                    </AccordionHeader>
                    <AccordionContent>
                        <div class="residences-container" style="position: relative;">
                            <!-- Loading overlay -->
                            <div v-if="isLoading" class="residences-loading-overlay">
                                <img :src="base_url + '/storage/circle-loader.gif'" alt="Loading..." class="loading-gif" />
                            </div>
                            
                            <div class="row align-items-end course-row py-2 justify-content-between">
                                <div class="col-12">
                                    <div class="d-flex align-items-start">
                                        <RadioButton class="ml-3 mt-2" v-model="residenceIdValue" :value="0" />
                                        <div>
                                            <h2 class="course-title">{{ tra.no_accommodation }}</h2>
                                            <p class="course-sub-title">{{ tra.no_need_accommodation }}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- Custom Residence Option -->
                            <div v-if="shouldShowCustomResidence"
                                class="row align-items-end course-row py-2 justify-content-between">
                                <div class="col-md-auto">
                                    <div class="d-flex align-items-start">
                                        <RadioButton class="ml-3 mt-2" v-model="residenceIdValue" :value="'custom_residence'" />
                                        <div>
                                            <h2 class="course-title">{{ customResidenceData.description }}</h2>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-auto" style="padding-right: 52px;">
                                    <div class="price-info d-flex align-items-end justify-content-md-end mt-2">
                                        <p class="price mb-0">
                                            {{ customResidenceData.price }}
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div v-for="residence in residences" :key="residence.id"
                                class="row align-items-end course-row py-2 justify-content-between">
                                <div class="col-md-auto">
                                    <div class="d-flex align-items-start">
                                        <RadioButton class="ml-3 mt-2" v-model="residenceIdValue" :value="residence.id" />
                                        <div>
                                            <h2 class="course-title">{{ residence.residence_type }}</h2>
                                            <p class="course-sub-title">{{ residence.description }}</p>
                                            <div>
                                                <Tag v-if="residence.min_age || residence.max_age" class="ml-2 course-tag" icon="fal fa-user"
                                                    :value="residence.age_text" />
                                                
                                                <Tag v-if="residence.residence_type" class="ml-2 course-tag" icon="fal fa-home"
                                                    :value="residence.residence_type" />
                                                
                                                <Tag v-if="residence.room_type" class="ml-2 course-tag" icon="fal fa-person-booth"
                                                    :value="residence.room_type" />
                                                
                                                <Tag v-if="residence.bath_type" class="ml-2 course-tag" icon="fal fa-bath"
                                                    :value="residence.bath_type" />
                                                
                                                <Tag v-if="residence.breakfast || residence.lunch || residence.dinner" 
                                                    class="ml-2 course-tag" icon="fal fa-utensils"
                                                    :value="residence.meals_text" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-auto" style="padding-right: 52px;">
                                    <div class="price-info d-flex align-items-end justify-content-md-end mt-2">
                                        <div class="d-flex ml-2 discounts-badges">
                                            <Tag v-if="residence.price.residence_discount_obj.total_discounts"
                                                class="institute-discount-badge"
                                                :value="tra.institute_discount + ' ' + residence.price.residence_discount_obj.total_discounts * 100 + '%'" />
                                        </div>

                                        <div v-if="residence.price.residence_discount_obj.total_discounts"
                                            class="d-flex align-items-end">
                                            <del class="text-danger">{{ residence.price.residence_price_formated }}</del>
                                            <p class="price mb-0 mr-2">
                                                {{ residence.price.residence_discounted_price_formated }}
                                            </p>
                                        </div>
                                        <div v-else>
                                            <p class="price mb-0">
                                                {{ residence.price.residence_price_formated }}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </AccordionContent>
                </AccordionPanel>
            </Accordion>

            <!-- Custom Residence Dialog -->
            <Dialog v-model:visible="showCustomResidenceDialog" :style="{ width: '450px' }" :modal="true" :closable="true">
                <div class="p-4">
                    <h3 class="mb-3">{{ tra.add_custom_accommodation }}</h3>
                    <div class="form-group mb-3">
                        <label>{{ tra.accommodation_description }}</label>
                        <input v-model="custom_residence.description" type="text" class="form-control"
                            :placeholder="tra.accommodation_description">
                    </div>
                    <div class="form-group mb-3">
                        <label>{{ tra.price_per_week }}</label>
                        <input v-model="custom_residence.price" type="number" class="form-control">
                    </div>
                    <div class="d-flex justify-content-end">
                        <button @click="showCustomResidenceDialog = false" type="button"
                            class="btn rounded-10 bg-secondary-color text-white ml-2">{{ tra.close }}</button>
                        <button @click="addCustomResidence" type="button"
                            class="btn rounded-10 bg-main-color text-white">{{ tra.add }}</button>
                    </div>
                </div>
            </Dialog>
        </div>
        <!-- <div class="col-xl-6 text-left">
                <button type="button" data-toggle="modal" data-target="#custom-residences-modal"
                    class="btn rounded-10 text-white bg-secondary-color mt-2 py-1 w-100">{{ tra.add_custom_accommodation }}</button>
            </div>
        <div class="modal fade" id="custom-residences-modal" tabindex="-1" aria-labelledby="successModalLabel"
            aria-hidden="true">
            <div class="modal-dialog modal-md">
                <div class="modal-content">
                    <button type="button" class="close modal-close-btn-absolute" data-dismiss="modal">&times;</button>
                    <div class="modal-body py-5 px-4 text-right">

                        <div class="p-2 my-4 custom-residence-box"
                            style='border:1px solid #009994 ; border-radius: 5px;'>
                            <div class="form-group">
                                <label>{{ tra.accommodation_description }}</label>
                                <input v-model="custom_residence.description" type="text" class="form-control"
                                    :placeholder="tra.accommodation_description">
                            </div>
                            <div class="form-group">
                                <label>{{ tra.price_per_week }}</label>
                                <input v-model="custom_residence.price" type="number" class="form-control">
                            </div>

                            <button @click="choosingCustomResidence" type="submit"
                                class="btn rounded-10 bg-main-color mb-3 text-white">{{ tra.add }}</button>
                        </div>

                        <button v-if="is_admin == '1'" @click="residence_id = 'custom_residence'" type="submit"
                            class="btn rounded-10 bg-secondary-color w-100 text-center mb-3 text-white">{{ tra.add_custom_accommodation }}
                        </button>

                    </div>
                </div>
            </div>
        </div> -->
    </div>
</template>

<script>
import Accordion from 'primevue/accordion';
import AccordionPanel from 'primevue/accordionpanel';
import AccordionHeader from 'primevue/accordionheader';
import AccordionContent from 'primevue/accordioncontent';
import RadioButton from 'primevue/RadioButton';
import Tag from 'primevue/Tag';
import Dropdown from 'primevue/dropdown';
import Dialog from 'primevue/dialog';
import WeeksComponent from './WeeksComponent.vue';
import debounce from 'lodash/debounce';

export default {
    components: {
        Accordion,
        AccordionPanel,
        AccordionHeader,
        AccordionContent,
        RadioButton,
        Tag,
        Dropdown,
        Dialog,
        WeeksComponent,
    },
    props: ['institute_id', 'base_url', 'pref_currency', 'start_date', 'courseWeeks', 'residenceWeeks', 'residenceId', 'customResidenceData', 'errors', 'old', 'tra', 'is_dashboard_user'],
    emits: ['update:residenceWeeks', 'update:residenceId', 'update:customResidence'],

    data() {
        return {
            residences: [],
            isInitialized: false,
            isLoading: false,
            showCustomResidenceDialog: false,
            custom_residence: {
                description: '',
                price: '',
            },
            residencesAbortController: null,
        };
    },
    
    computed: {
        residenceWeeksValue: {
            get() {
                return this.residenceWeeks;
            },
            set(value) {
                this.$emit('update:residenceWeeks', value);
            }
        },
        residenceIdValue: {
            get() {
                return this.residenceId;
            },
            set(value) {
                this.$emit('update:residenceId', value);
            }
        },

        // Check if we have minimum required data
        canFetchResidences() {
            return this.institute_id && this.start_date;
        },

        // Check if custom residence should be shown as an option
        shouldShowCustomResidence() {
            return this.customResidenceData && this.customResidenceData.description && this.customResidenceData.price;
        }
    },
    
    methods: {
        getResidences() {
            // Cancel previous request if exists
            if (this.residencesAbortController) {
                this.residencesAbortController.abort();
            }

            if (!this.canFetchResidences) {
                return;
            }

            // Create new AbortController for this request
            this.residencesAbortController = new AbortController();

            this.isLoading = true;

            axios.get(this.base_url + '/api/get-residences', {
                signal: this.residencesAbortController.signal,
                params: {
                    institute_id: this.institute_id,
                    residence_weeks: this.residenceWeeksValue,
                    start_date: this.start_date,
                    pref_currency: this.pref_currency,
                    lang: window.current_locale,
                },
            }).then((response) => {
                this.residences = response.data;
                this.isLoading = false;
            }).catch((error) => {
                // Ignore cancelled requests
                if (error.code === 'ERR_CANCELED' || error.message === 'canceled') {
                    console.log('Residences request cancelled - new request started');
                    this.isLoading = false;
                    return;
                }

                console.error('Error fetching residences:', error);
                this.isLoading = false;
                if (error.response && error.response.status === 429) {
                    console.warn('Rate limit exceeded for residences. Retrying in 2 seconds...');
                    setTimeout(() => {
                        this.getResidences();
                    }, 2000);
                }
            });
        },

        createDebouncedMethods() {
            this.debouncedGetResidences = debounce(this.getResidences, 800);
        },
        addCustomResidence() {
            if (this.custom_residence.description && this.custom_residence.price) {
                this.showCustomResidenceDialog = false;
                // Emit custom residence data to parent component
                this.$emit('update:customResidence', this.custom_residence);
                // Set residence_id to trigger API call only when Add button is clicked
                this.residenceIdValue = 'custom_residence';
            }
        },
        choosingCustomResidence: function () {
            this.residenceIdValue = 'custom_residence';
        },
    },
    
    watch: {
        start_date: {
            handler() {
                if (this.isInitialized && this.canFetchResidences) {
                    this.debouncedGetResidences();
                }
            },
            immediate: false
        },
        residenceWeeks: {
            handler() {
                if (this.isInitialized && this.canFetchResidences) {
                    this.debouncedGetResidences();
                }
            },
            immediate: false
        },
    },

    created() {
        this.createDebouncedMethods();
    },
    
    mounted() {
        this.$nextTick(() => {
            // Set initial values
            this.$emit('update:residenceWeeks', this.residenceWeeksValue || this.courseWeeks);
            
            // Set old values if they exist
            if (this.old.residence_id) {
                this.residenceIdValue = Number(this.old.residence_id);
            }

            // Delay initialization to prevent immediate API calls
            setTimeout(() => {
                this.isInitialized = true;
                if (this.canFetchResidences) {
                    this.getResidences();
                }
            }, 600);
        });
    },
};
</script>

<style scoped>
.residences-loading-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(255, 255, 255, 0.8);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10;
}

.loading-gif {
    width: 50px;
    height: 50px;
}

.course-calculator-card{
    min-height: 150px;
}

.custom-residence-btn {
    margin-left: auto;
    padding: 8px 16px;
    font-size: 14px;
}

.custom-residence-btn i {
    margin-right: 6px;
}
</style>